import * as yup from "yup";
import moment from "moment";
import { ROLES } from "../../../constants";
import { AVATAR, CV, DATE, DATE_OF_APPOINTMENT, DATE_OF_CERTIFICATION, DATE_OF_RESIGNATION, DATE_OF_TENURE_COMPLETION, EMAIL, GCP_CERTIFICATE_1, GCP_CERTIFICATE_2, IS_AFFILIATED_TO_MEDANTA, MEDICAL_REGISTRATION_CERTIFICATE, MEMBER_TYPE, NAME, NEXT_GCP_CERTIFICATE_DUE_ON, PASSWORD, QUALIFICATION, REASON_FOR_RESIGNATION, RESIGN_LETTER, ROLE, ROLES_IN_EC, ROLES_IN_EC_OTHERS, SIGNED_CONFIDENTIALITY_AGREEMENT, SIGNED_CONFLICT_OF_INTEREST, TRAININGS, VALID_UPTO, _URL } from "../../../constants/forms";

export const createMemberInitData = {
  [EMAIL]: "",
  [NAME]: "",
  [PASSWORD]: "",
  [ROLE]: ROLES.MIRB,
  [GCP_CERTIFICATE_1]: "",
  [GCP_CERTIFICATE_2]: "",
  [AVATAR]: "",
  [CV]: "",
  [DATE_OF_TENURE_COMPLETION]: moment().format("yyyy-MM-DD"),
  [DATE_OF_APPOINTMENT]: moment().format("yyyy-MM-DD"),
  [DATE_OF_CERTIFICATION]: moment().format("yyyy-MM-DD"),
  [DATE_OF_RESIGNATION]: "",
  [IS_AFFILIATED_TO_MEDANTA]: true,
  [MEDICAL_REGISTRATION_CERTIFICATE]: "",
  [MEMBER_TYPE]: ROLES.MIRB,
  [NEXT_GCP_CERTIFICATE_DUE_ON]: moment().format("yyyy-MM-DD"),
  [QUALIFICATION]: [""],
  [REASON_FOR_RESIGNATION]: "",
  [RESIGN_LETTER]: "",
  [ROLES_IN_EC]: "",
  [ROLES_IN_EC_OTHERS]: "",
  [SIGNED_CONFIDENTIALITY_AGREEMENT]: "",
  [SIGNED_CONFLICT_OF_INTEREST]: "",
  [TRAININGS]: [
    {
      [DATE]: moment().format("yyyy-MM-DD"),
      [_URL]: "",
      [NAME]: "",
    },
  ],
  [VALID_UPTO]: moment().format("yyyy-MM-DD"),
};

const memberDetailsValidations = yup.object().shape({
  [NAME]: yup.string().required("Name is required"),
  [QUALIFICATION]: yup
    .array(
      yup
        .string()
        .required(
          "All fields are required, please remove empty fields if not needed"
        )
    )
    .required("Qualification is required"),
  [ROLES_IN_EC]: yup.string().required("Qualification is required"),
});

const termsOfAppointmentValidations = yup.object().shape({
  [DATE_OF_TENURE_COMPLETION]: yup.date().required("Please enter a valid date"),
  [DATE_OF_APPOINTMENT]: yup.date().required("Please enter a valid date"),
  [SIGNED_CONFIDENTIALITY_AGREEMENT]: yup
    .string()
    .required("Please upload a copy of the signed confidentiality agreement"),
  [SIGNED_CONFLICT_OF_INTEREST]: yup
    .string()
    .required("Please upload a copy of the signed conflict of interest"),
});

const qualificationsValidations = yup.object().shape({
  [CV]: yup.string().required("Please upload a copy of CV"),
  [MEDICAL_REGISTRATION_CERTIFICATE]: yup.string(),
  // .required("Please upload a copy of medical registration  certificate"),
});

const goodClinicalPracticeValidations = yup.object().shape({
  [GCP_CERTIFICATE_1]: yup
    .string()
    .required("Please upload a copy of GCPCertificate"),
  [DATE_OF_CERTIFICATION]: yup.date().required("Date of certification is required"),
  [VALID_UPTO]: yup.date().required("Validation date is required"),
  [NEXT_GCP_CERTIFICATE_DUE_ON]: yup
    .date()
    .required("Next GCP Certificate date is required"),
});

const trainingValidations = yup.object().shape({
  [TRAININGS]: yup
    .array(
      yup.object().shape({
        date: yup.date().required("Date of training is required"),
        url: yup.string().required("Certificate is required"),
        name: yup.string().required("Name is required"),
      })
    )
    .min(1, "Please add training")
    .required("Trainings are required"),
});

const resignTermsValidations = yup.object().shape({
  [DATE_OF_RESIGNATION]: yup.string().when([REASON_FOR_RESIGNATION, RESIGN_LETTER], {
    is: (reasonForResignation: string, resignLetter: string) => reasonForResignation || resignLetter,
    then: yup.string().required('Date of resignation is required')
  }),
  [REASON_FOR_RESIGNATION]: yup.string().when([DATE_OF_RESIGNATION, RESIGN_LETTER], {
    is: (dateOfResignation: string, resignLetter: string) => dateOfResignation || resignLetter,
    then: yup.string().required('Please enter the reason for resign')
  }),
  [RESIGN_LETTER]: yup.string().when([DATE_OF_RESIGNATION, REASON_FOR_RESIGNATION], {
    is: (dateOfResignation: string, reasonForResignation: string) => dateOfResignation || reasonForResignation,
    then: yup.string().required('Please enter the resign letter')
  }),
  [EMAIL]: yup.string().email("Invalid email").required("Email is required"),
  [PASSWORD]: yup.string().required("Password is required"),
},[[DATE_OF_RESIGNATION, REASON_FOR_RESIGNATION], [DATE_OF_RESIGNATION, RESIGN_LETTER], ['reasonForResignation','resignLetter']]);

const _resignTermsValidations = yup.object().shape({
  [DATE_OF_RESIGNATION]: yup.date(),
  [REASON_FOR_RESIGNATION]: yup.string(),
});

export const createECMemberValidationSchema = [
  // resignTermsValidations,
  memberDetailsValidations,
  termsOfAppointmentValidations,
  qualificationsValidations,
  goodClinicalPracticeValidations,
  trainingValidations,
  resignTermsValidations,
];

export const editECMemberValidationSchema = [
  memberDetailsValidations,
  termsOfAppointmentValidations,
  qualificationsValidations,
  goodClinicalPracticeValidations,
  trainingValidations,
  _resignTermsValidations,
];
